export default {
	edit: 'Edit',
	delete: 'Delete',
}
